import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import Search from '../../../Search';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import './../ManageOrders/ManageOrders.scss';
import { toastr } from '../../../../../Redux/Actions/CommonActions';
import { ROOT_API_URL } from '../../../../../api-config';
import { DonationsLoader } from './DonationsLoader';
import GridDateFormatter from '../../../GridDateFormatter';
import '../ManageUsers/ManageUser.scss';
import { auth } from '../../../../../services/auth.service';
import axios from 'axios';
import DialogContainer from './Dialogs/DialogContainer';
import cellWithEditing from './CellWithEditing';
import Modal from 'react-modal';

const FileDownload = require('js-file-download');

class ManageDonations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            donationInEdit: {},
            isPopupVisible: false,
            donations: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: []
                },
                sort: [{ field: "createDate", dir: "desc" }]
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        };
    }

    dataStateChange = (e) => {
        if (e.data && e.data.filter && e.data.filter.filters) {
            var filters = e.data.filter.filters;

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].field && filters[i].field == "createDate") {
                    var operator = filters[i].operator;

                    if ((operator == "gt" || operator == "gte") && !filters[i].value) {

                        filters[i].value = new Date('January 01, 1900');

                    } else if ((operator == "lt" || operator == "lte") && !filters[i].value) {

                        var currentDatetime = new Date();

                        filters[i].value = new Date(Date.UTC(currentDatetime.getFullYear(), currentDatetime.getMonth(), currentDatetime.getDate()));

                    }
                } else if (filters[i].field && (filters[i].field == "donationId" || filters[i].field == "MembershipId" || filters[i].field == "actualCostDecimal")) {
                    var operator = filters[i].operator;

                    if (!filters[i].value && (operator == "lt" || operator == "lte" || operator == "gt" || operator == "gte")) {

                        filters[i].value = 0;

                    }

                } else if (filters[i].value == null) {
                    filters[i].value = "";
                }
            }
        }

        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (donationsFetched) => {
        this.setState({
            ...this.state,
            donations: donationsFetched,
            isLoading: false
        });

        if (donationsFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (donationsFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    edit = (dataItem) => {
        this.setState({
            donationInEdit: Object.assign({}, dataItem),
            isPopupVisible: true
        });
    };

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        if (!arr) {
            return null;
        }
        else {
            for (var i = 0; i < arr.length; i++) {
                var element = arr[i];
                for (var key in arr[i]) {
                    element[key] = element[key] + '';
                }
                arr[i] = element;
            }
            return arr;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj(this.state.dataState.filter.filters) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj(this.state.dataState.sort) : null;
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : []
        }

        axios.get(ROOT_API_URL + "/ManageTransaction/ExportDonationsToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Donations.csv');
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    edit = (dataItem) => {
        this.setState({
            donationInEdit: Object.assign({}, dataItem),
            isPopupVisible: true
        });
    };
  
    render() {
        return (
            <div id={"donations-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading donations" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.donations.total}
                                {...this.state.dataState}
                                {...this.state.donations}
                                onDataStateChange={this.dataStateChange}
                            >
                                <GridToolbar>
                                    {/*<div className="admin-grid-toolbar-box1">
                                        <Search customFunc={this.filterSize} />
                                        <Switch
                                            // style="width:70px"
                                            filter="boolean"
                                            onChange={this.handleChange}
                                            onLabel={'Active'}
                                            offLabel={'InActive'}
                                            checked={this.state.toggled}
                                        />
                                    </div>*/}

                                    <div className="admin-grid-toolbar-box2">
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column filterable={false} cell={cellWithEditing(this.edit)} />
                                <Column field="donationId" title="Transaction Id" filter="numeric"/>
                                <Column field="MembershipId" title="Membership Id" filter="numeric"/>
                                <Column field="donationType" title="Type" />
                                <Column field="name" title="Name" />
                                <Column field="address1" title="Address" />
                                <Column field="phone" title="Phone" />
                                <Column field="actualCostDecimal" title="Amount" className="align-cells-right" filter="numeric" format="{0:c2}"/>
                                <Column field="createDate" title="Date" cell={GridDateFormatter} filter="date" />
                            </Grid>
                        </div>                        
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <DonationsLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>
                    {
                        this.state.isPopupVisible ? (
                            <Modal
                                isOpen={Boolean(this.state.donationInEdit)}
                                onRequestClose={this.cancel}
                                contentLabel="Example Modal"
                                ariaHideApp={false}
                                style={{
                                    content: {
                                        top: '50%',
                                        left: '50%',
                                        right: 'auto',
                                        bottom: 'auto',
                                        marginRight: '-50%',
                                        minWidth: '80vw',
                                        maxWidth: '80vw',
                                        minHeight: '80vh',
                                        maxHeight: '80vh',
                                        overflow: 'auto',
                                        transform: 'translate(-50%, -50%)',
                                        borderRadius: '5px'
                                    }
                                }}
                            >
                                <DialogContainer
                                    dialogType="edit"
                                    dataItem={this.state.donationInEdit}
                                    cancel={this.cancel}
                                />
                            </Modal>
                        ) : ""
                    }
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
	return {
		donation: state.purchaseAndRenewals,
		common: state.common
	};
}

export default connect(mapStateToProps, {
	toastr
})(ManageDonations);
